/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResourcesDto } from './ResourcesDto';
export type NodeResponseDTO = {
  name: string;
  networkName: string;
  nodeType: NodeResponseDTO.nodeType;
  nodeAddress?: string;
  nodeUrl?: string;
  nodeStatus?: NodeResponseDTO.nodeStatus;
  createdBy?: string;
  nodeCreationDate?: string;
  /**
   * A node is created externally
   */
  external?: boolean;
  resources?: ResourcesDto;
  besuImage?: string;
  besuImageSecret?: string;
};
export namespace NodeResponseDTO {
  export enum nodeType {
    VALIDATOR = 'VALIDATOR',
    BOOT = 'BOOT',
    RPC = 'RPC',
  }
  export enum nodeStatus {
    INITIALIZING = 'INITIALIZING',
    INITFAILED = 'INITFAILED',
    INITSUCCEEDED = 'INITSUCCEEDED',
    RUNNING = 'RUNNING',
    CRASHED = 'CRASHED',
  }
}
